let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fy8a4")).then(() => parcelRequire('ebKZ6'));